import React from 'react';
import Col from 'react-bootstrap/Col';
import UserReview from './UserReview';

const UserReviewGroup = (props) => {
    const {list, page, editReview, handleDelete} = props;

    const showList =  list.map( r =>
                        <Col xs={12} key={r.id}>
                            <UserReview editReview={editReview} info={r} handleDelete={handleDelete} />
                        </Col>);
    
    return (
        <>
            {showList}
        </>
    );
}

export default UserReviewGroup;